const media = {
  sm: `min-width: ${576}px`,
  md: `min-width: ${768}px`,
  lg: `min-width: ${1050}px`,
  xl: `min-width: ${1440}px`,
};

export default media;
